
(function() {
  var result = { translations: { "no-no": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tm", "hoursAndMinutes": "{{ hours }} tm {{ minutes }} min", "days": "{{ days }} dager", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}t", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}t {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, utvidelse {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "no": "static-7.1091"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1091",
    "ar-eg": "static-7.1091",
    "bg": "static-7.1091",
    "bn": "static-7.1091",
    "ca-es": "static-7.1091",
    "cs": "static-7.1091",
    "da": "static-7.1091",
    "de": "static-7.1091",
    "el": "static-7.1091",
    "en-gb": "static-7.1091",
    "en": "static-7.1091",
    "es-mx": "static-7.1091",
    "es": "static-7.1091",
    "et": "static-7.1091",
    "fi": "static-7.1091",
    "fr-ca": "static-7.1091",
    "fr": "static-7.1091",
    "he-il": "static-7.1091",
    "hi": "static-7.1091",
    "hr": "static-7.1091",
    "hu": "static-7.1091",
    "id": "static-7.1091",
    "it": "static-7.1091",
    "ja": "static-7.1091",
    "ko": "static-7.1091",
    "lt": "static-7.1091",
    "ms": "static-7.1091",
    "nl": "static-7.1091",
    "no": "static-7.1091",
    "pl": "static-7.1091",
    "pt-br": "static-7.1091",
    "pt-pt": "static-7.1091",
    "ro": "static-7.1091",
    "ru": "static-7.1091",
    "sk": "static-7.1091",
    "sl": "static-7.1091",
    "sv": "static-7.1091",
    "th": "static-7.1091",
    "tl": "static-7.1091",
    "tr": "static-7.1091",
    "uk": "static-7.1091",
    "vi": "static-7.1091",
    "x-pseudo": "static-7.1091",
    "zh-cn": "static-7.1091",
    "zh-hk": "static-7.1091",
    "zh-tw": "static-7.1091"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:no', {version: 'static-7.1091'}); }
})();


